var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.484.125a1 1 0 0 1 .502 1.04L11.181 6H14a1 1 0 0 1 .707 1.708l-8 8a1 1 0 0 1-1.693-.873L5.819 10H2a1 1 0 0 1-.664-1.748l9-8a1 1 0 0 1 1.148-.127ZM4.632 7.999H7a1 1 0 0 1 .986 1.166l-.486 2.92 4.085-4.084H10a1 1 0 0 1-.986-1.166l.534-3.206L4.632 8Z"
  })));
};
export default SvgFlash;